import React from 'react'
import classNames from 'classnames'

const InputText = ({
  error,
  touched = true,
  status,
  statusMessage,
  ...props
}) => {
  return (
    <div className="control is-expanded">
      <input
        className={classNames('input', {
          'is-danger': error && touched,
          'is-success': status === 'success',
          'is-warning': status === 'warning',
        })}
        type="text"
        onTouchMove={() => console.log('on Touse')}
        {...props}
      />
      {statusMessage && (
        <p
          className={classNames('help has-text-right', {
            'has-text-weight-bold': status === 'warning',
          })}
        >
          {statusMessage}
        </p>
      )}
      {touched && (
        <p className={classNames('help', { 'is-danger': error })}> {error} </p>
      )}
    </div>
  )
}

export default InputText



// WEBPACK FOOTER //
// ./src/components/views/widgets/InputText.js